import { call, put } from 'redux-saga/effects';
import { alertPush, sendError } from '../../../';
import { changePasswordData, changePasswordError, ChangePasswordFetch } from '../actions';
import api from '../../../../api-new/http';
import { appUrls } from '../../../../api-new/urls';

export function* changePasswordSaga(action: ChangePasswordFetch) {
    try {
        // yield call(API.put(changePasswordOptions(getCsrfToken())), '/resource/users/password', action.payload);
        const token = localStorage.getItem('csrfToken');
        if (!token) {
            throw new Error('Token not found');
        }

        yield call(() =>
            api.post(`${appUrls.authenURL}/change-password`, action.payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            }),
        );
        
        yield put(changePasswordData());
        yield put(alertPush({ message: ['✅ Password Changed', 'Your password has been updated successfully. Please use your new password to log in.'], type: 'success' }));
    } catch (error: any) {
            const errorSetup = {
                message: error.response.data.errors[0].errorMessage,
                code: error.response.status,
                codeConfig: error.response.data.errors[0].errorCode,
            };
            yield put(
                sendError({
                    error: errorSetup,
                    processingType: 'alert',
                    extraOptions: {
                        actionError: changePasswordError,
                    },
                }),
            );
    }
}
